import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Grid, Tabs, Tab, Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AccountComponent from './components/AccountComponent'
import ChangePassword from './components/ChangePassword'

const useStyles = makeStyles((theme) => ({
  tabsContent: {
    margin: '20px 0',
    boxShadow: 'unset',
    '& .MuiTabs-flexContainer': {
      backgroundColor: 'white',
      borderBottom: '3px solid #f44336'
    },
    '& .MuiButtonBase-root': {
      // backgroundColor: theme.colorAccent,
      color: theme.colorAccent
    },
    '& .Mui-selected': {
      backgroundColor: theme.colorAccent,
      color: 'white'
    }
  }
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Profile = props => {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <Grid item xs={12} >
      <AppBar position="" className={classes.tabsContent}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="ACCOUNT" {...a11yProps(0)} />
          <Tab label="CHANGE PASSWORD" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <AccountComponent />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ChangePassword />
      </TabPanel>
    </Grid>
  )
}

Profile.propTypes = {

}

export default Profile